/** Whether `access` grants a nav item keyed by `key` (admin always passes; undefined/'all' = everyone; an array grants when ANY key matches). */
export function hasNavAccess(key, access) {
    if (Array.isArray(key))
        return key.some((k) => hasNavAccess(k, access));
    const k = key;
    if (!k || k === 'all')
        return true;
    // The game has its own audience (trial players + its admin); app-wide admin is not part of it.
    if (k === 'gamePlayer')
        return access.isGamePlayer || access.isGameOperator;
    // Lead MO: MONET+LEAD or the named eCode list (moLead.eCodes) — same pattern as gamePlayer
    // above. Admins are NOT let in by role alone (user decision 28/09/2026).
    if (k === 'moLead')
        return access.canMoLead;
    if (access.isAdmin)
        return true;
    switch (k) {
        case 'ua': return access.isUa;
        // UA only, not the DA that 'ua' also covers (user decision 28/09/2026) — see AccessProfile.canLocalize.
        case 'localize': return access.canLocalize;
        case 'monet': return access.isMonet || access.monetOnly;
        // Admin or a per-page grant, not a department — see AccessProfile.canCreativeSpy.
        case 'creativeSpy': return access.canCreativeSpy;
        // Also a named list rather than a department: this one changes real Google Ads budgets.
        case 'gadsEditor': return access.canGadsEditor;
        case 'dev': return access.isDev || access.hasDevApps;
        // DEV department only — per-app assigned outsiders (hasDevApps) don't get dev tools.
        case 'devDept': return access.isDev;
        case 'hr': return access.isHr;
        // HR lead manages HR Admin; HR staff (isHr but not lead) do not.
        case 'hrLead': return access.isHrLead;
        case 'aso': return access.isAso;
        case 'cto': return access.isCto;
        case 'cmo': return access.isCmo;
        case 'designLead': return access.isDesignLead;
        case 'monetLead': return access.isMonetLead;
        case 'monetAssign': return access.canMonetAssign;
        // admin | CMO | CTO | COO | department lead — resolved server-side from the API's own read gate,
        // because jtCode never reaches the client and a copy of the rule here would drift from it again.
        case 'commission': return access.canReadCommission;
        // Active employee with a company address — outside logins (nine external developers) are not.
        case 'employee': return access.isEmployee;
        // SPN004 (user decision 2026-09-28): reaches /admin for the Sidebar tab without app-wide
        // admin. Not folded into 'admin' above — that key means "admin only", and this grants a
        // narrower, named right instead.
        case 'toggleNav': return access.canToggleNav;
        case 'admin': return false;
    }
}
//# sourceMappingURL=nav-access.contract.js.map